import { ICh_ChoirState } from "../models/interfaces";
import { TChoirActionTypes } from "../models/choirActions";
import { GET_CHOIR, GET_CHOIR_ERROR } from "../types";

export default (position: ICh_ChoirState = null, action: TChoirActionTypes): ICh_ChoirState => {
    switch (action.type) {
        case GET_CHOIR:
            return action.payload;
        case GET_CHOIR_ERROR:
            return 'error';
        default:
            return position;
    }
};
